<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(loadingSrDetail){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="5"
      ></app-skeleton-loader>
      } @if(!loadingSrDetail){
      <form [formGroup]="form">
        <!-- Notes section -->
        @if (srNumber && srInprgoressAwating && !loadingSrDetail) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        }
        <!-- End notes -->
         
        <section>
          <div class="fields-container">
            <!-- business select -->
            <div class="field-control">
              <app-option-field
                [label]="'ADD_BUSINESS.SELECT_BUSINESS' | translate"
                [placeholder]="
                  'ADD_BUSINESS.SEARCH_COMPANY_PLACEHOLDER' | translate
                "
                [options]="members"
                [control]="form.get('company')!"
                (search)="handleSearch($event)"
                [loading]="loadingMember"
                [showMemberFilter]="true"
                [valueKey]="'Value'"
                [labelKey]="'Name'"
                (onSelectionChange)="getLinkedUsers()"
              ></app-option-field>
              @if(selectedCompany){
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-5">
                <div class="relative border border-dc-navy p-4 text-dc-navy">
                  <!-- Owner Info -->
                  <div class="mb-5">
                    <h3 class="text-lg font-semibold text-dc-navy mb-1">
                      {{ selectedCompany.nameEnglish }}<br />
                      {{ selectedCompany.nameArabic }}
                    </h3>

                    <p class="text-sm text-dc-navy!">
                      {{ "COMPANY.COUNTRY" | translate }}<br />
                      <span class="text-lg font-semibold">
                        {{ selectedCompany.country || "-" }}
                      </span>
                    </p>

                    <p class="text-sm text-dc-navy!">
                      {{ "COMPANY.EMAIL" | translate }}<br />
                      <span class="text-lg font-semibold">
                        {{ selectedCompany.email || "-" }}
                      </span>
                    </p>

                    <p class="text-sm text-dc-navy!">
                      {{ "COMPANY.PHONE" | translate }}<br />
                      <span class="text-lg font-semibold">
                        {{ selectedCompany.phone || "-" }}
                      </span>
                    </p>

                    <p class="text-sm text-dc-navy!">
                      {{ "COMPANY.CITY" | translate }}<br />
                      <span class="text-lg font-semibold">
                        {{ selectedCompany.city || "-" }}
                      </span>
                    </p>

                    <p class="text-sm text-dc-navy!">
                      {{ "COMPANY.ADDRESS" | translate }}<br />
                      <span class="text-lg font-semibold">
                        {{ selectedCompany.address || "-" }}<br />
                        {{ selectedCompany.poBox || "-" }}<br />
                        {{ selectedCompany.city || "-" }}
                      </span>
                    </p>
                  </div>
                  <!-- Bottom green corner -->
                  <div class="dc-card-corner-blue"></div>
                </div>
              </div>
              }
            </div>
          </div>
          <!-- role section -->
          <h3 class="section-heading mt-8">
            {{ "ADD_BUSINESS.ROLE_TITLE" | translate }}
          </h3>
          <div class="fields-container">
            <div class="space-y-2" formArrayName="roles">
              @for (option of roles; let i = $index; track option) {
              <div>
                <div class="card-edge-cut relative border-blue">
                  <div class="card-body mb-5">
                    <div class="flex gap-5">
                      <input
                        type="checkbox"
                        [value]="option.value"
                        [formControlName]="i"
                        class="h-5 w-5 text-dc-navy border-gray-300 accent-dc-navy mt-1"
                      />
                      <div class="text-dc-navy!">
                        <span class="font-semibold">{{
                          lang == "en" ? option.label : option.label_ar
                        }}</span>
                        <p class="text-dc-navy! py-2">
                          {{
                            lang == "en"
                              ? option.description
                              : option.description_ar
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              } @if (form.get('roles')?.invalid && form.get('roles')?.touched) {
              <div class="text-red-500 text-sm">
                {{ "VALIDATION_MSG.SELECT_ROLE" | translate }}
              </div>
              }
            </div>
          </div>

          <!-- contact details -->
          <h3 class="section-heading mt-10">
            {{ "ADD_BUSINESS.CONTACT_TITLE" | translate }}
          </h3>
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="'ADD_BUSINESS.EMAIL' | translate"
                [control]="form.get('email')!"
                [validationMessages]="{
                  email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                }"
              >
              </app-text-field>
            </div>
            <div class="field-control">
              <app-mobile-number
                class="mt-4"
                [label]="'ADD_BUSINESS.PHONE' | translate"
                [countryCodeControl]="form.get('countryCode')!"
                [control]="form.get('phone')!"
                [validationMessages]="{
                  mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                  uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                }"
              />
            </div>
             <div class="field-control">
              <app-mobile-number
                class="mt-4"
                [label]="'ADD_BUSINESS.OFFICE_LANDLINE' | translate"
                [countryCodeControl]="form.get('officePhoneCountryCode')!"
                [control]="form.get('officePhone')!"
                [validationMessages]="{
                  uaePhoneNumber: 'VALIDATION_MSG.VALID_UAE_PHONE_NUMBER' | translate,
                  mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                  uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                }"
              />
            </div>
          </div>

          @if (srFolder && mainFromSectionDocs.length) {
          <h3 class="section-heading mt-10">{{
            'ADD_BUSINESS.UPLOAD_DOCUMENTS' | translate
            }}</h3>
          <div class="fields-container">
            @for (dt of mainFromSectionDocs; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                [showAction]="showActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.UM_UA"
              ></app-file>
            </div>
            }
          </div>
          }

          <!-- Error Message -->
          @if (errorMsg) {
          <app-validation-message
            [type]="'error'"
            [showCloseIcon]="false"
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message: errorMsg
            }"
          >
          </app-validation-message>
          } @if(technicalErrorMsg){
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
            }"
            [showbutton]="false"
          ></app-validation-message>
          }
          <!-- buttons -->
          <div class="btn-section buttons-group">
            @if(showActions && !formSubmitLoader){
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'ADD_BUSINESS.SUBMIT' | translate"
              (onBtnClick)="saveDraftOrSubmitFormData()"
            >
            </app-button>

            <app-button
              classesName="card-edge-cut-white btn-width-auto"
              [label]="'ADD_BUSINESS.REMIND' | translate"
              (onBtnClick)="remindLater()"
            >
            </app-button>
            } @if(formSubmitLoader){
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'PLEASE_WAIT' | translate"
              [disabled]="true"
            >
            </app-button>
            }
          </div>

          <!-- approve reject -->
          @if (requestDetail && requestDetail["Status"] == srStatus.InProgress && showApproveAction)
          {
          <div class="btn-section buttons-group">
            @if(!formSubmitLoader){
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'ACCOUNT.ACTIONS.APPROVE' | translate"
              (onBtnClick)="approveRejectRequest('approve', requestDetail)"
            >
            </app-button>

            <app-button
              classesName="card-edge-cut-white btn-width-auto"
              [label]="'ACCOUNT.ACTIONS.REJECT' | translate"
              (onBtnClick)="approveRejectRequest('reject', requestDetail)"
            >
            </app-button>
            }
          </div>
          }
        </section>
      </form>
      }
    </div>
  </div>
</div>
<app-service-progress
  [serviceName]="'ADD_BUSINESS.SERVICE_NAME' | translate"
  [showProgress]="false"
/>

@if(otpModal){
<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
    <div class="text-center">
      <!-- <button class="modal-x-button" type="button" (click)="otpModal = false">
        <i class="fas fa-close"></i>
      </button> -->

      <p class="text-lg font-semibold mb-2">
        {{ "OTP_SEND_PRAIMARY_ACCOUNT" | translate }}
      </p>
      <div class="mt-6 flex flex-col gap-2 mb-4">
        <input
          type="text"
          [placeholder]="'ENTER_OTP' | translate"
          class="w-fullform-input w-full px-3 py-2 text-dc-navy font-light transition border focus:outline-none disabled:cursor-not-allowed disabled:bg-[#eeeeee] border-dc-navy/40"
          name="otpText"
          [(ngModel)]="otpText"
          (ngModelChange)="onOtpChange($event)"
          (keyup.enter)="validateOtp()"
        />
        @if(otpErrorKey){
        <span class="text-sm font-medium text-red-600 text-left!">
          {{ otpErrorKey | translate }}
        </span>
        }
      </div>
      <div class="flex justify-center gap-4">
        <app-button
          type="button"
          classesName="btn-edge-cut min-w-30 px-4 py-2"
          [label]="'BUTTONS.RESEND_OTP' | translate"
          (onBtnClick)="resendOtp()"
        >
        </app-button>

        <app-button
          type="button"
          classesName="card-edge-cut-white min-w-30  px-4 py-2"
          label="Logout"
          [label]="'BUTTONS.SUBMIT' | translate"
          (onBtnClick)="validateOtp()"
        >
        </app-button>
      </div>
    </div>
  </div>
</div>

}

@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
